import { Customer } from '../types';
import { Actions, ActionTypes } from './actions';
import { Actions as AddressesActions, ActionTypes as AddressesActionTypes } from './addresses/actions';
import { Actions as CompanyActions, ActionTypes as CompanyActionTypes } from './company/actions';
import { Actions as AttributesActions, ActionTypes as AttributesActionTypes } from './attributes/actions';
import { CustomerToken } from '../../types/customers';

export interface FieldUpdate {
    [name: string]: {
        error: string | null;
        isLoading: boolean;
    };
}

export interface State {
    isLoading: boolean;
    isNotFound: boolean;
    customer: Customer | undefined;
    tokens: CustomerToken[] | undefined;
    basicInfoUpdates: FieldUpdate;
    deleteCustomerModalOpen: boolean;
    changeCustomerIdModalOpen: boolean;
    changeCustomerIdError: string;
}

export const initialState: State = {
    isLoading: false,
    isNotFound: false,
    customer: undefined,
    tokens: undefined,
    basicInfoUpdates: {},
    deleteCustomerModalOpen: false,
    changeCustomerIdModalOpen: false,
    changeCustomerIdError: '',
};

export function reducer(state: State = initialState, action: Actions | AddressesActions | CompanyActions | AttributesActions) {
    switch (action.type) {
        case ActionTypes.GetCustomer:
            if (state.customer && state.customer.id === action.payload.id) {
                return { ...state };
            }
            return {
                ...initialState,
                isLoading: true,
            };

        case ActionTypes.CustomerResponse:
            return {
                ...state,
                customer: action.payload.customer,
                isLoading: false,
            };

        case ActionTypes.CustomerNotFoundResponse:
            return {
                ...state,
                isLoading: false,
                isNotFound: true,
            };

        case ActionTypes.EditCustomerField:
            return {
                ...state,
                basicInfoUpdates: {
                    ...state.basicInfoUpdates,
                    [action.payload.name]: {
                        isLoading: true,
                        error: null,
                    },
                },
            };

        case ActionTypes.FetchEditCustomerFieldResponse:
            return {
                ...state,
                customer: action.payload.customer,
                isLoading: false,
                basicInfoUpdates: {
                    ...state.basicInfoUpdates,
                    [action.meta.cause.payload.name]: {
                        isLoading: false,
                        error: null,
                    },
                },
            };
        case ActionTypes.CustomerTokensResponse:
            return {
                ...state,
                tokens: action.payload.tokens,
            };
        case AddressesActionTypes.FetchEditCustomerAddressesResponse:
        case AddressesActionTypes.FetchAddCustomerAddressesResponse:
        case CompanyActionTypes.FetchEditCustomerCompanyResponse:
        case AttributesActionTypes.FetchEditCustomerAttributesResponse:
            return {
                ...state,
                customer: action.payload.customer,
            };

        case ActionTypes.OpenDeleteCustomerModal:
            return {
                ...state,
                deleteCustomerModalOpen: true,
            };

        case ActionTypes.CloseDeleteCustomerModal:
            return {
                ...state,
                deleteCustomerModalOpen: false,
            };

        case ActionTypes.FetchDeleteCustomerResponse:
            return {
                ...state,
                deleteCustomerModalOpen: false,
                isNotFound: true,
                customer: undefined,
            };
        case ActionTypes.ToggleChangeCustomerIdModal:
            return {
                ...state,
                changeCustomerIdModalOpen: action.payload.open,
                changeCustomerIdError: initialState.changeCustomerIdError,
            };
        case ActionTypes.ChangeCustomerIdError:
            return {
                ...state,
                changeCustomerIdError: action.payload.newCustomerId,
            };

        default:
            return state;
    }
}
